import React, { useEffect, useState } from "react";
import _ from "lodash";
import {
  Box,
  Button,
  Fab,
  IconButton,
  InputAdornment,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import FittingMasterAdd from "./FittingMasterAdd";
import FittingViewDialog from "./FittingViewDialog";
import { CloudDownload } from "@material-ui/icons";
import axios from "axios";
import {
  DeleteAllFittingMasterAPI,
  DeleteFittingMasterAPI,
  GetAllFittingMastersAPI,
} from "../../config/api";
import { ConfirmationDialog } from "../../components/common";
import FittingMasterEdit from "./FittingMasterEdit";
import Checkbox from "@material-ui/core/Checkbox";
import People from "@material-ui/icons/People";
import CustomInput from "../../components/CustomInput/CustomInput";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as XLSX from 'xlsx';
import { baseUrl } from "../../config/api";


const useStyles = makeStyles((theme) => ({
  fab: {
    position: "absolute",
    bottom: theme.spacing(-24),
    right: theme.spacing(2),
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
}));

const columns = [
  { id: "image", label: "Image" },
  { id: "fittingType", label: "Fitting Type" },
  {
    id: "amount",
    label: "Amount",
    format: (value) => {
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return numValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
    },
  },
  { id: "action", label: "Action" },
];

export default function FittingMasterList() {
  const classes = useStyles();
  let authToken = useSelector((state) => state.userReducer.authToken);
  let userInfo = useSelector((state) => state.userReducer.userInfo);
  const [fittings, setFittings] = useState([]);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openViewDialog, setOpenViewDialog] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(null);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isExporting, setIsExporting] = useState(false);

  useEffect(() => {
    _getFittings();
  }, []);

  async function _getFittings() {
    try {
      let res = await axios.get(GetAllFittingMastersAPI(userInfo.entity), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      console.log('fittingMasters', res.data.fittingMasters);
      setFittings(res.data.fittingMasters);
    } catch (err) {
      // console.log(err);
      // toast.error(("Something went wrong, Please Contact Admin") , {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      //   }); 
    }
  }

  async function _deleteItem(item) {
    try {
      let res = await axios.delete(DeleteFittingMasterAPI(item._id), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      window.location.reload();
    } catch (e) {
      // console.log("err:", e);
      // toast.error(("Something went wrong, Please Contact Admin") , {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      //   }); 
    }
  }

  async function _deleteAllRecords() {
    try {
      if (_.isEmpty(selectedRows)) {
        return;
      }
      let res = await axios.post(
        DeleteAllFittingMasterAPI(userInfo.entity),
        {
          data: selectedRows,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      window.location.reload();
    } catch (e) {
      // console.log("err:", e);
      // toast.error(("Something went wrong, Please Contact Admin") , {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      //   }); 
    }
  }

  const handleOpenConfirmationModal = (object) => {
    setOpenConfirmationModal(object);
  };

  const handleCloseConfirmationModal = () => {
    setOpenConfirmationModal(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function closeAddDialog() {
    setOpenAddDialog(false);
  }

  function closeViewDialog() {
    setOpenViewDialog(null);
  }

  function closeEditDialog() {
    setOpenEditDialog(null);
  }

  let data = fittings;
  if (searchTerm !== "") {
    data = _.filter(data, (i) => {
      return (
        i.fittingType &&
        i.fittingType.toLowerCase().includes(searchTerm.toLowerCase())
      );
    });
  }
  let excelData = [];
  data.map((i) => {
    let d = [];
    d.push({ value: i.fittingType });
    d.push({ value: i.amount });
    excelData.push(d);
  });
  const multiDataSet = [
    {
      columns: [{ title: "fittingType" }, { title: "amount" }],
      data: excelData,
    },
  ];


  // XLSX Export Function
  const handleExport = async () => {
    setIsExporting(true);
    try {
      // First, get the total count
      const totalRes = await axios.get(
        GetAllFittingMastersAPI(userInfo.entity) + `?limit=1&skip=0`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const total = totalRes.data.total || 0;
      
      if (total === 0) {
        toast.error('No data to export!');
        setIsExporting(false);
        return;
      }

      // Fetch all data using the total count
      const res = await axios.get(
        GetAllFittingMastersAPI(userInfo.entity) + `?limit=${total}&skip=0`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const allData = res.data.fittingMasters;
      if (!allData || allData.length === 0) {
        toast.error('No data to export!');
        setIsExporting(false);
        return;
      }

      const exportHeadings = [
        { id: "fittingType", label: "Fitting Type" },
        { id: "amount", label: "Amount" }
      ];

      const exportData = allData.map(row => {
        const rowData = {};
        exportHeadings.forEach(col => {
          let value = row[col.id];
          rowData[col.id] = value;
        });
        return rowData;
      });

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'FittingMaster');
      XLSX.writeFile(workbook, 'fitting_master_export.xlsx');
      toast.success('Exported to Excel!');
    } catch (error) {
      console.error('Export error:', error);
      toast.error('Failed to export all data!');
    } finally {
      setIsExporting(false);
    }
  };
  return (
    <>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Button
          color="primary"
          onClick={() =>
            handleOpenConfirmationModal({
              msg: "Do you want to delete all records",
              onPress: () => _deleteAllRecords(),
            })
          }
        >
          Delete All Records
        </Button>

        <Box justifyContent={"center"} alignItems={"center"}>
          <Tooltip title={"Export to excel"}>
            <IconButton
              color={"primary"}
              onClick={handleExport}
              disabled={isExporting}
            >
              <CloudDownload />
            </IconButton>
          </Tooltip>
          <CustomInput
            id="search"
            formControlProps={{
              fullWidth: false,
            }}
            inputProps={{
              style: {
                color: "primary",
                marginTop: 0,
              },
              placeholder: "Search",
              value: searchTerm,
              onChange: (e) => setSearchTerm(e.target.value),
              endAdornment: (
                <InputAdornment position="end">
                  <People />
                </InputAdornment>
              ),
            }}
          />
          <IconButton aria-label="add" onClick={() => setOpenAddDialog(true)}>
            <AddIcon />
          </IconButton>
        </Box>
      </Box>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <Checkbox
              style={{
                color: "#512da8",
              }}
              onChange={(e) => {
                let c = [];
                if (e.target.checked) {
                  data.map((i) => {
                    c.push(i._id);
                  });
                }
                setSelectedRows(c);
              }}
              checked={
                selectedRows.length > 0 && data.length === selectedRows.length
              }
              inputProps={{ "aria-labelledby": -1 }}
            />
            {columns.map((column) => (
              <TableCell
                key={column.id}
                align={"center"}
                style={{ minWidth: column.minWidth }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      style={{
                        color: "#512da8",
                      }}
                      onChange={() => {
                        let copy = _.clone(selectedRows);
                        if (_.includes(copy, row._id)) {
                          let index = _.indexOf(copy, row._id);
                          copy.splice(index, 1);
                        } else {
                          copy.push(row._id);
                        }
                        setSelectedRows(copy);
                      }}
                      checked={_.includes(selectedRows, row._id)}
                      inputProps={{ "aria-labelledby": row._id }}
                    />
                  </TableCell>
                  {columns.map((column) => {
                    let value = row[column.id];
                    if (column.id === "discountedFittings") {
                      value = !_.isEmpty(row.data) ? row.data.length : 0;
                    }
                    if (column.id === "image") {
                      return (
                        <TableCell key={column.id} align={"center"}>
                          {row.image ? (
                            <Box
                              component="img"
                              src={`${baseUrl}${row.image}`}
                              alt={row.fittingType || "Fitting"}
                              style={{
                                width: 60,
                                height: 60,
                                objectFit: "cover",
                                borderRadius: 4,
                                cursor: "pointer",
                              }}
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                              onClick={() => {
                                if (row.image) {
                                  window.open(`${baseUrl}${row.image}`, "_blank");
                                }
                              }}
                            />
                          ) : (
                            <Box
                              style={{
                                width: 60,
                                height: 60,
                                backgroundColor: "#f5f5f5",
                                borderRadius: 4,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#999",
                                fontSize: "12px",
                              }}
                            >
                              No Image
                            </Box>
                          )}
                        </TableCell>
                      );
                    }
                    if (column.id === "action") {
                      return (
                        <TableCell align={"center"}>
                          <Box display={"flex"} justifyContent={"center"}>
                            {/* <IconButton
                              aria-label="view"
                              onClick={() =>
                                setOpenViewDialog({
                                  open: true,
                                  item: row,
                                })
                              }
                            >
                              <VisibilityIcon />
                            </IconButton> */}
                            <IconButton
                              aria-label="edit"
                              onClick={() =>
                                setOpenEditDialog({
                                  open: true,
                                  item: row,
                                })
                              }
                            >
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                handleOpenConfirmationModal({
                                  onPress: () => _deleteItem(row),
                                })
                              }
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        </TableCell>
                      );
                    }
                    return (
                      <TableCell key={column.id} align={"center"}>
                        {column.format && (typeof value === "number" || !isNaN(Number(value)))
                          ? column.format(Number(value))
                          : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {/*<Fab color="primary" aria-label="add" className={classes.fab}*/}
      {/*     onClick={() => setOpenAddDialog(true)}>*/}
      {/*    <AddIcon/>*/}
      {/*</Fab>*/}
      <FittingMasterAdd
        fetchData={_getFittings}
        open={openAddDialog}
        close={closeAddDialog}
      />
      {openViewDialog ? (
        <FittingViewDialog
          open={openViewDialog.open}
          close={closeViewDialog}
          item={openViewDialog.item}
        />
      ) : null}
      {openEditDialog ? (
        <FittingMasterEdit
          open={openEditDialog.open}
          close={closeEditDialog}
          item={openEditDialog.item}
          fetchData={_getFittings}
        />
      ) : null}
      {openConfirmationModal ? (
        <ConfirmationDialog
          open={openConfirmationModal}
          onClose={handleCloseConfirmationModal}
          onConfirm={openConfirmationModal.onPress}
          title={"Delete Record"}
          msg={openConfirmationModal.msg}
        />
      ) : null}
      <Backdrop
        open={isExporting}
        style={{
          zIndex: 9999,
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress size={60} thickness={4} style={{ color: '#512da8', marginBottom: 20 }} />
          <Box style={{ fontSize: '18px', fontWeight: 'bold', marginTop: 10 }}>
            Exporting Data...
          </Box>
          <Box style={{ fontSize: '14px', marginTop: 5, opacity: 0.8 }}>
            Please wait while we prepare your Excel file
          </Box>
        </Box>
      </Backdrop>
    </>
  );
}
